import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { PATH_CONTRACTORS } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useContractorContext } from "../context";

export const useContractorBreadcrumbs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const context = useContractorContext();

  const breadcrumbItems = useMemo((): BreadcrumbItem[] => {
    const isCreateMode = location.pathname.endsWith("/new");

    const items: BreadcrumbItem[] = [
      {
        label: t("contractors.title.multiple"),
        href: PATH_CONTRACTORS,
      },
    ];

    if (isCreateMode) {
      items.push({
        label: t("contractors.createForm.title"),
        href: undefined,
      });
    } else if (context.data) {
      items.push({
        label: context.data.full_name || context.data.id,
        href: `${PATH_CONTRACTORS}/${context.data.id}`,
      });
    }

    return items;
  }, [location.pathname, t, context.data]);

  return {
    breadcrumbItems,
  };
};
